const motiveList = [
  {
    MotiveId: 1,
    MotiveName: 'Aniversario',
    MotiveCodeMajestic: 'ANIVERSARI',
    MotiveType: 'ANIVERSARY',
  },
  {
    MotiveId: 2,
    MotiveName: 'Cumpleaños',
    MotiveCodeMajestic: 'CUMPLEAÑOS',
    MotiveType: 'BIRTHDAY',
  },
  {
    MotiveId: 3,
    MotiveName: 'Luna de miel',
    MotiveCodeMajestic: 'LUNADEMIEL',
    MotiveType: 'HONEYMOON',
  },
  {
    MotiveId: 4,
    MotiveName: 'Vacaciones',
    MotiveCodeMajestic: 'VACACIONES',
    MotiveType: 'VACATIONS',
  },
  {
    MotiveId: 5,
    MotiveName: 'Otro',
    MotiveCodeMajestic: 'OTROS',
    MotiveType: 'OTHERS',
  },
];

export default motiveList;
